import React, { ReactNode } from 'react';
import { Typography } from 'antd';
import styles from './LargeButton.module.css';

export interface LargeButtonProps {
  text: ReactNode
  textOnRight: boolean
  textLevel: 1 | 2 | 3 | 4 | 5
  iconSrc: string
  iconAlt: string
  iconSize: number
  lightBackground: boolean
};

// displays large styled button with text and icon
const LargeButton = (props: LargeButtonProps): JSX.Element | null => {
  const textElement = (
    <Typography.Title className={styles.buttonText} level={props.textLevel}>
      {props.text}
    </Typography.Title>
  );

  return (
    <div className={`${styles.mainContainer} ${props.lightBackground ? styles.lightBg : styles.darkBg}`}>
      {!props.textOnRight && textElement}
      <img src={props.iconSrc} alt={props.iconAlt} style={{width: props.iconSize, height: props.iconSize}} />
      {props.textOnRight && textElement}
    </div>
  );
};

export default LargeButton;
